import React, { useCallback, useState } from 'react';

/* A plate on a project page.
 *
 * Fixing the width, as this did, meant an image's shape decided how big it
 * got: at 560 wide a portrait plate covered 418k pixels and a 16:9 one only
 * 176k, so the widest work — brand slides, layouts, anything landscape —
 * always came out smallest. Now every plate is drawn to the same area, so a
 * wide one runs wider and a tall one runs narrower and they carry equal
 * weight on the page.
 *
 * The anchor is the old measure: a 4:3 plate still lands at exactly 560x420.
 * Everything else flexes around it, clamped so nothing runs away.
 */

const PLATE_AREA = 560 * 420;   // the measure, as an area
const MIN_W = 420;
const MAX_W = 760;

export default function Plate({ src, alt, eager, onOpen }) {
  const [width, setWidth] = useState(null);

  const measure = useCallback((e) => {
    const img = e.target;
    if (!img.naturalWidth || !img.naturalHeight) return;
    const ratio = img.naturalWidth / img.naturalHeight;
    const w = Math.round(Math.max(MIN_W, Math.min(MAX_W, Math.sqrt(PLATE_AREA * ratio))));
    setWidth(w);
  }, []);

  return (
    <div className="main-image plate" style={width ? { width: `${width}px` } : undefined}>
      <img
        src={src}
        alt={alt || ''}
        loading={eager ? undefined : 'lazy'}
        onLoad={measure}
        onClick={onOpen}
      />
    </div>
  );
}
